module.exports = __webpack_public_path__ + "static/media/me-blacked.d4978b0c.png";